import { Directive, forwardRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { AuthorizationService } from '../services/authorization.service';
import { AuthorizeOrganisationBase } from './authorize-organisation.base';
import { AUTHORIZERS } from './authorizer';

@Directive({
  selector: '[authorizeOrganisationAny]',
  providers: [
    {
      provide: AUTHORIZERS,
      useExisting: forwardRef(() => AuthorizeOrganisationAnyDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class AuthorizeOrganisationAnyDirective extends AuthorizeOrganisationBase {
  @Input('authorizeOrganisationAny') permissions?: OrganisationPermissionType[];

  constructor(authorizationService: AuthorizationService, router: Router) {
    super(authorizationService, router);
  }

  protected isAuthorizedForOrganisation(organisationId: number) {
    if (!organisationId) {
      return of(false);
    }

    const permissions = this.permissions || [];
    if (permissions.length === 0) {
      return of(true);
    }

    return combineLatest(
      permissions.map(permission => super.isAuthorizedForPermission(organisationId, permission)),
    ).pipe(map(isAuthorizedResults => isAuthorizedResults.some(x => !!x)));
  }
}
